import classnames from 'classnames';
import * as R from 'ramda';
import React, {useRef, useState} from 'react';
import {Link, Route} from 'react-router-dom';
import useOnClickOutside from 'use-onclickoutside';
import {pathLogout, pathPrivacyPolicy} from 'iss/paths';

import getRoutes from 'iss/routes';
import {translate} from 'iss/strings';
import {formatParty} from 'iss/widgets/format/Party';

const isStaging = window.location.hostname.match(/-staging/) != null;

function Navigation({party}) {
  const [collapsed, setCollapsed] = useState(true);
  const menuItems = R.filter(R.prop('menuTitle'), getRoutes(party));
  const toggleCollapsed = () => setCollapsed(R.not);

  let classNames = "navbar navbar-default navbar-static-top";

  // Couldn't find any kind of theme definition so just add a class if we are on staging
  // so that the user is reminded of the environment being used. If I'd know how to change
  // link text color, then perhaps a darker color could be used + the 'active' style
  // color should be different as well so that the 'staging theme' wouldn't look as half baked as it does now :(
  if (isStaging) {
    classNames = "navbar-staging " + classNames;
  }

  return <nav className={classNames}>
    <div className="container-fluid">
      <div className="navbar-header">
        <button type="button" className={classnames("navbar-toggle", {collapsed})} aria-expanded={!collapsed} onClick={toggleCollapsed}>
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
        <Link className="navbar-brand" to="/">{translate('navigation.title') + (isStaging ? ' TEST' : '')}</Link>
      </div>
      <div className={classnames("collapse navbar-collapse", {in: !collapsed})}>
        <ul className="nav navbar-nav">
          {menuItems.map(({id, menuTitle, path, link}) => {

            if (link === undefined) {
              return (
                <Route key={path} path={path} children={({ match }) => (
                  <li className={match ? 'active' : ''}>
                    <Link id={"link-to-"+id} to={path}>{translate(menuTitle)}</Link>
                  </li>
                )}/>
              );
            } else {
              return (
                <li key={link}>
                  <a id={"link-to-"+id} href={link}>{translate(menuTitle)}</a>
                </li>
              );
            }
          })}
        </ul>
        <ul className="nav navbar-nav navbar-right">
          <Dropdown text={formatParty(party, "short")} toggleId="username">
            <li><Link id="privacyPolicy" to={pathPrivacyPolicy} target='_blank'>{translate('loginForm.downloadPrivacyPolicy')}</Link></li>
            <li><Link id="logout" to={pathLogout}>{translate('navigation.logout')}</Link></li>
          </Dropdown>
        </ul>
      </div>
    </div>
  </nav>;
}

function Dropdown(props) {
  const ref = useRef();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(R.not);
  useOnClickOutside(ref, () => setExpanded(false));

  return <li ref={ref} role="presentation" className={classnames('dropdown', {open: expanded})}>
    <a id={props.toggleId} className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={expanded} onClick={toggle}>
      {props.text} <span className="caret"></span>
    </a>
    <ul className="dropdown-menu" onClick={toggle}>
      {props.children}
    </ul>
  </li>;
}

export default Navigation;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Navigation.jsx